import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.monarchhomesofbrevard.com";
const DEFAULT_IMG = SITE_URL + "/images/new/n-3.jpg";

const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  keywords,
  type = "website",
  jsonLd
}) => {
  const fullTitle = title
    ? `${title} | Monarch Homes of Brevard`
    : "Monarch Homes of Brevard | Premier Custom Home Builder in Brevard County, FL";
  const url = `${SITE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Monarch Homes of Brevard" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
